import React from 'react';

const number = (value, unit, divisor = 1) => Number.isFinite(value) ? `${(value / divisor).toFixed(1)} ${unit}` : 'Unavailable';
const stamp = value => value.replace('T', ' ').replace(':00:00Z', ':00 UTC');

export default function StormTiming({ benchmark, report }) {
  if (!report || !benchmark || report.benchmarkId !== benchmark.id || !report.cases.length) return null;
  return <section className="rekkie-snow-stations" aria-label="Storm timing investigation">
    <h3>Storm timing investigation</h3>
    <p>Largest snowfall error per station. Hourly values are forecasts; observations cover the full daily interval.</p>
    {report.cases.map(row => {
      const maximum = Math.max(1, ...row.hours.map(hour => hour.snowfallMm || 0));
      const width = 620 / row.hours.length;
      return <article key={row.caseId} className="rekkie-snow-station">
        <h4>{row.date} · {row.stationId}</h4>
        <p>{stamp(row.targetFrom)} → {stamp(row.targetUntil)}</p>
        <div className="rekkie-snow-table-wrap"><table>
          <thead><tr><th>Daily amount</th><th>HRRR</th><th>Measured</th></tr></thead>
          <tbody><tr><th scope="row">New snowfall</th><td>{number(row.forecastMm, 'in', 25.4)}</td><td>{number(row.observedMm, 'in', 25.4)}</td></tr>
            <tr><th scope="row">Total precipitation</th><td>{number(row.precipForecastMm, 'mm')}</td><td>{number(row.precipObservation.precipMm, 'mm')}</td></tr></tbody>
        </table></div>
        <p>Model 2 m temperature: {number(row.temperatureMinC, '°C')} to {number(row.temperatureMaxC, '°C')}.</p>
        <p>Valid hourly differences: {row.snowHoursValid}/{row.hoursExpected} snowfall · {row.precipHoursValid}/{row.hoursExpected} precipitation. Missing or decreasing fields stay excluded.</p>
        <h4>Hourly HRRR snowfall</h4>
        <svg viewBox="0 0 700 160" role="img" aria-label={`Hourly forecast snowfall for ${row.date}, in inches`} style={{ width: '100%', maxWidth: 900 }}>
          <text x="0" y="18" fill="#a8b9cd" fontSize="12">{number(maximum, 'in', 25.4)}</text>
          <line x1="55" y1="120" x2="680" y2="120" stroke="#475569" />
          {row.hours.map((hour, index) => <g key={hour.until}>
            {hour.snowfallMm === null ? <text x={55 + index * width} y="116" fill="#fbbf24" fontSize="12">?</text> :
              <rect x={55 + index * width} y={120 - hour.snowfallMm / maximum * 95} width={Math.max(1, width - 3)} height={hour.snowfallMm / maximum * 95} fill="#7dd3fc">
                <title>{stamp(hour.until)} · {number(hour.snowfallMm, 'in', 25.4)}</title>
              </rect>}
            {index % 4 === 0 && <text x={55 + index * width} y="142" fill="#a8b9cd" fontSize="11">{hour.until.slice(11, 16)}</text>}
          </g>)}
          <text x="55" y="158" fill="#a8b9cd" fontSize="10">Hour ending (UTC) · ? = excluded</text>
        </svg>
        <details><summary>Hourly values and measurement checks</summary>
          <p>{row.limitation}</p>
          {row.precipObservation.status !== 'matched' && <p>Precipitation measurement unavailable: {row.precipObservation.reason}</p>}
          <div className="rekkie-snow-table-wrap"><table>
            <thead><tr><th>Hour ending (UTC)</th><th>New snow</th><th>Precipitation</th><th>Temperature at hour end</th></tr></thead>
            <tbody>{row.hours.map(hour => <tr key={hour.until}><th scope="row">{stamp(hour.until)}</th>
              <td title={hour.snowError || ''}>{number(hour.snowfallMm, 'in', 25.4)}</td>
              <td title={hour.precipError || ''}>{number(hour.precipMm, 'mm')}</td>
              <td>{number(hour.temperatureC, '°C')}</td></tr>)}</tbody>
          </table></div>
          <p>Run {report.id} · Model initialized {stamp(row.initializedAt)}</p>
          <a href={row.precipObservation.source.url} target="_blank" rel="noreferrer">NOAA station measurements ↗</a>
        </details>
      </article>;
    })}
  </section>;
}
